import React, { useState, useEffect, useContext } from "react"
import {
    Box,
    VStack,
    Center,
    Select,
} from "@chakra-ui/react"
import InfoModal from "../components/modals/InfoModal"
import Const from "../Consts"
import { Twirp, TwirpProps } from "../components/functions/Twirp"
import { useTranslation } from 'react-i18next';

type CountryListProps = {
    selectedFunction: (chosen: number) => void
};
export default function CountryList(props: CountryListProps) {
    const { t, i18n } = useTranslation();

    type SingleListItem = {
        value: number,
        label: string,
        disabled?: boolean
    }
    const defaultCountry = [{disabled: true, value:0, label:t("-select-")}]
    const [itemData, setItemData] = useState<SingleListItem[]>(defaultCountry)
    // const [selectedItem, setSelectedItem] = useState<number>(0)

    const [modalData, setModalData] = useState({
        title: "",
        main: "",
        isOpen: false,
    })
    const closeModal = () => {
        setModalData({ ...modalData, isOpen: false })
    }

    const onItemSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value
        props.selectedFunction(+value)//convert to number
    }

    const populateData = async () => {

        const props: TwirpProps = {
            url: Const.API_ListCountries, headers: {}, timeout: 5000, data: {}
        }
        const result = await Twirp(props)
        if (result.state == 2) {//other error
            setModalData({ ...modalData, isOpen: true, title: result.axiosError.code, main: result.axiosError.message })
        } else if (result.state == 1) {//twirp controlled error
            setModalData({ ...modalData, isOpen: true, title: result.axiosError.code, main: result.axiosError.message })
        } else { //successful
            closeModal()

            type CommonResult = {
                id: number,
                nama: string
            }
            const commons = result.data.Commons as CommonResult[]
            const resultCountries = commons.map(d => (
                {
                    label: d.nama,
                    value: d.id
                }
            ))
            setItemData([...defaultCountry, ...resultCountries])

        }
    }

    useEffect(() => {
        populateData()
    }, [])


    return (
        <Box py={"0px"} px={"0px"}  maxW='m' borderWidth='0px'  overflow='hidden'>
            <InfoModal isOpen={modalData.isOpen} title={modalData.title} mainText={modalData.main} closeFunction={closeModal} />

            <Center py={"0px"} px={"0px"} maxW='m' borderWidth='0px' overflow='hidden' >
                <VStack>

                    <Select minW={['158px','192px']} size='sm'  onChange={onItemSelected} defaultValue={0}>
                        {itemData.map(({ value, label }) => (
                            <option key={value} value={value} disabled={value==0}>
                                {label}
                            </option>
                        ))}
                    </Select>

                </VStack>
            </Center>
        </Box>

    )

}
